import SelfLearningDetailAPI from '@/apis/business/MISAStore/self-learning-detail-api.js'
export default {
  namespaced: true,

  state: {
    selfLearningCourseDetails: []
  },

  getters: {},

  mutations: {
    // set giá trị danh sách bài tập
    setSelfLearningCourseDetails (state, data) {
      state.selfLearningCourseDetails = data
    }
  },

  actions: {
    /**
     * @author TTLONG
     * @description get quiz lesson
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async getQuizInLesson (context, params) {
      return new Promise((resolve, reject) => {
        SelfLearningDetailAPI.getAsync(`quiz/${params}`)
          .then((res) => {
            if (res && res.Data) {
              const data = JSON.parse(res.Data)
              let dataObject = data
              if (typeof data !== 'object') {
                dataObject = JSON.parse(data)
              }

              resolve(dataObject)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    async getSelfLearningCourseDetails (context, params) {
      return new Promise((resolve, reject) => {
        SelfLearningDetailAPI.getAsync(`course-detail?partnerID=${params.partnerID}&type=${params.type}`)
          .then((res) => {
            if (res && res.Data) {
              const data = res.Data
              const categorys = data.map(item => {
                return item.Category
              })
              // lấy các category không trùng nhau
              const categoryUnique = []
              categorys.forEach(element => {
                if (!categoryUnique.includes(element)) {
                  categoryUnique.push(element)
                }
              })
              const categoryGroup = []
              categoryUnique.forEach(item => {
                const category = {}
                category.Category = item
                category.Course = []
                data.forEach(element => {
                  if (item === element.Category) {
                    category.Course.push(element)
                  }
                })
                category.Course.sort((a, b) => {
                  return a.SortOrder - b.SortOrder
                })
                categoryGroup.push(category)
              })
              // const dataConvert = data.map((item) => {
              //   item.Quiz = JSON.parse(JSON.parse(item.Quiz))
              //   return item
              // })
              context.commit(
                'setSelfLearningCourseDetails', categoryGroup

              )
              resolve(data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
